module.exports = __webpack_public_path__ + "static/media/close.72932cc0.svg";